import styles from '../TargetGroupTable.module.css';
import React from 'react';
import {
    AnalysisAPI,
    ReportAPI,
} from '../../../../typings/participant_activity';

interface CandidateReportStatusProps {
    report?: ReportAPI;
    analysis?: AnalysisAPI;
    hasErrorStatus: boolean;
    participantEmail?: string;
    groupType?: string;
    hasStarted?: boolean;
}

const CandidateReportStatus: React.FunctionComponent<
    CandidateReportStatusProps
> = (props) => {
    const {
        report,
        analysis,
        hasErrorStatus,
        participantEmail,
        groupType,
        hasStarted,
    } = props;

    const isAnonymousSnapFit = !participantEmail && groupType === 'SNAP_FIT';

    // SnapFit registration fires a pre-warm that creates a `pending` Analysis
    // row before the user has started. In contexts that don't fetch activity
    // (the table row), `hasStarted` is undefined and we'd otherwise mislabel
    // every newly registered SnapFit user as "Analysing". Pre-warm sets
    // created_at == updated_at; the real /analyze flow bumps updated_at via
    // UpdateAnalysisStatus. A meaningful gap means analysis has actually run.
    const PREWARM_TIMESTAMP_DELTA_MS = 2000;
    const analysisLooksPrewarmed = (() => {
        if (!analysis) return false;
        const created = Date.parse(analysis.created_at);
        const updated = Date.parse(analysis.updated_at);
        if (Number.isNaN(created) || Number.isNaN(updated)) return false;
        return updated - created < PREWARM_TIMESTAMP_DELTA_MS;
    })();
    const prewarmLikelyNotStarted =
        hasStarted === false ||
        (hasStarted === undefined &&
            groupType === 'SNAP_FIT' &&
            analysisLooksPrewarmed);
    const showAnalysing =
        !report &&
        analysis?.status === 'pending' &&
        !hasErrorStatus &&
        !prewarmLikelyNotStarted;
    const showNotStartedForPending =
        !report &&
        analysis?.status === 'pending' &&
        !hasErrorStatus &&
        prewarmLikelyNotStarted;

    return (
        <>
            {!!report && analysis?.status !== 'pending' && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#1AA277',
                    }}>
                    Completed
                </span>
            )}

            {!!report && analysis?.status === 'pending' && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#1AA277',
                    }}>
                    Partially completed
                </span>
            )}

            {!report && analysis?.status === 'done' && isAnonymousSnapFit && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#1AA277',
                    }}>
                    Completed
                </span>
            )}

            {showAnalysing && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: 'rgba(95, 145, 204, 1)',
                    }}>
                    Analysing
                </span>
            )}

            {!report && analysis?.status === 'pending' && hasErrorStatus && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#F6510E',
                    }}>
                    Failed
                </span>
            )}

            {(!report && !analysis) || showNotStartedForPending ? (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#BBC9D8',
                    }}>
                    Not started
                </span>
            ) : null}
        </>
    );
};

export default CandidateReportStatus;
